'use client';
import { useState, useEffect, useMemo, useRef } from 'react';
import React from 'react';
import {
   Box,
   Drawer,
   DrawerBody,
   DrawerCloseButton,
   DrawerContent,
   DrawerHeader,
   DrawerOverlay,
   Flex,
   Input,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorModeValue,
   useDisclosure,
} from '@chakra-ui/react';
import 'jspdf-autotable';
import Select from 'react-select';
import Card from 'components/card/Card';
import { GridItem } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { Button, Image, Thead, Th, Grid } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import json from '../../../../../src/assets/img/nfts/json.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
// import { getCompanies } from '../../../../redux/actions/company';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import { getReportTds } from '../../../../redux/actions/reports';
import { columnsReportsSalesDetail } from '../../customDataTable/variables/columnsData';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import { useBusinessType, useGlobal } from '../../../../contexts';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';

const TDSREPORT = () => {
   const columnHelper = createColumnHelper();
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const { companyList } = useGlobal();
   // const company = useSelector((state) => state.company.list);
   const [fromDate, setFromDate] = useState(null);
   const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
   // const [compOptions, setCompOptions] = useState(["comp update"]); // Default option

   const dispatch = useDispatch();
   const { businessTypes } = useBusinessType();

   const fromDateInputRef = useRef(null);
   const { isOpen, onOpen, onClose } = useDisclosure();

   // useEffect(() => {
   //   dispatch(getCompanies()); // Fetch companies when the component mounts
   // }, [dispatch]);

   useEffect(() => {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 1);
      const formattedDate = today.toISOString().split('T')[0];
      setFromDate(formattedDate);
   }, []);

   const [companyFilter, setCompanyFilter] = useState([]);
   const handleCompanyChange = (selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   };

   const tdsReport = useSelector((state) => state.reports?.tds || []);
   const [columnVisibility, setColumnVisibility] = React.useState(
      columnsReportsSalesDetail.reduce((acc, column) => {
         acc[column.id] = true;
         return acc;
      }, {}),
   );
   const companyOptions = useMemo(() => {
      return companyList?.map((comp) => ({
         value: comp.id,
         label: comp.name,
      }));
   }, [companyList]);

   const lastcompanyOptions = companyOptions.map((company) => ({
      value: company.value,
      label: company.label,
      id: company.value,
      name: company.label,
   }));

   useEffect(() => {
      const storedCompanyId = localStorage.getItem('companyId');
      if (storedCompanyId && companyList?.length > 0) {
         const companyId = parseInt(storedCompanyId);
         // Find the company in the company list that matches the stored ID
         const matchingCompany = companyList?.find((comp) => comp.id === companyId);

         if (matchingCompany) {
            // Create an option object for react-select
            // const option = { value: matchingCompany.id, label: matchingCompany.name };
            // Update the company filter state
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const isTargetInput =
            e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA' ||
            e.target.tagName === 'SELECT' ||
            e.target.isContentEditable;

         if (e.key.toLowerCase() === 't' && !isTargetInput) {
            if (fromDateInputRef.current) {
               fromDateInputRef.current.focus();
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);

      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, []);

   const generateLast40Months = () => {
      const months = [];
      const currentDate = new Date();
      for (let i = 0; i < 40; i++) {
         const year = currentDate.getFullYear();
         const month = currentDate.toLocaleString('en-US', { month: 'short' }); // Example: "Feb"

         months.push(`${month} ${year}`);

         // Move to the previous month
         currentDate.setMonth(currentDate.getMonth() - 1);
      }
      return months;
   };

   const secondOptions = generateLast40Months();

   const columns = columnsReportsSalesDetail
      .filter((column) => columnVisibility[column.id])
      .map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color="gray.400">
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   const table = useReactTable({
      tdsReport,
      columns,
      // state: { sorting },
      // onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   useEffect(() => {
      // Create the companyId array
      const companyIds =
         companyFilter.length > 0
            ? companyFilter // This already contains the company IDs
            : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [];

      // Dispatch with the params
      dispatch(
         getReportTds({
            itemId: 0,
            companyIds: companyIds,
            // reportType: itemWiseSelected ? itemWiseSelected.value : 0,
            fromDate,
            toDate,
         }),
      );
   }, [dispatch, companyFilter, fromDate, toDate]);

   // useEffect(()=> {
   //   dispatch(getReportTds())
   // },[dispatch])

   return (
      <>
         {/* Title Outside Card */}

         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()} // Navigate to the previous page
                  style={{ cursor: 'pointer' }} // Ensure it's clickable
               ></img>
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  TDS REPORT
               </Text>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex className="flex flex-wrap gap-2" alignItems="center" justifyContent={{ base: 'end', lg: 'center' }}>
               <Flex flex="" mr={3} display={{ base: 'none', xl: 'block' }}>
                  <div flex="1" mr={''} justifyContent="center">
                     <Box
                        my={2}
                        width="300px"
                        fontSize={'13px'}
                        fontWeight={500}
                        display={{ base: 'none', xl: 'block' }}>
                        <GridItem className="seperator-width" mt={5}>
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                     </Box>
                  </div>
               </Flex>
               <Flex flex="2" display={{ base: 'none', xl: 'flex' }}>
                  <Box my={2} mr={3} fontSize={'13px'} fontWeight={500} w={'180px'}>
                     <label>From Date</label>
                     <Input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        ref={fromDateInputRef}
                        w={'180px'}
                        h={'30px'}
                     />
                  </Box>
                  <Box my={2} fontSize={'13px'} fontWeight={500} w={'180px'}>
                     <label>To Date</label>
                     <Input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        w={'180px'}
                        h={'30px'}
                     />
                  </Box>
               </Flex>
               <Flex flex="1"></Flex>
               <Flex>
                  <Popover>
                     <PopoverTrigger>
                        {/* Image as Clickable Button */}
                        <img src={Download} alt="Download" width="25" style={{ cursor: 'pointer' }} />
                     </PopoverTrigger>

                     <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                        <PopoverBody p="3">
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={() => alert('Option 1 Selected')}
                              justifyContent="space-between"
                              mb={3}>
                              <img src={xls} alt="Download XLS" width="30px"></img>
                              Download Execl
                           </Button>
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={() => alert('Option 2 Selected')}
                              justifyContent="space-between">
                              <img src={json} alt="Download json" width="30px" mr></img>
                              Download JSON
                           </Button>
                        </PopoverBody>
                     </PopoverContent>
                  </Popover>
               </Flex>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter, // Filter based on companyFilter values
                                 onChange: handleCompanyChange, // Handle change
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true, // isSearchable
                              undefined, // filteredOptions (optional, can be null or undefined)
                              true, // isMulti
                           )}
                        </GridItem>

                        <Box my={2} fontSize="13px" fontWeight={500}>
                           <label>From Date</label>
                           <Input
                              type="date"
                              value={fromDate}
                              onChange={(e) => setFromDate(e.target.value)}
                              w="100%"
                              h="40px"
                              mb={3}
                           />
                        </Box>

                        <Box my={2} fontSize="13px" fontWeight={500}>
                           <label>To Date</label>
                           <Input
                              type="date"
                              value={toDate}
                              onChange={(e) => setToDate(e.target.value)}
                              w="100%"
                              h="40px"
                              mb={3}
                           />
                        </Box>

                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '70vh', md: '70vh', xl: '75vh' }}
                  maxH={{ base: '70vh', md: '70vh', xl: '75vh' }}>
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                     <Thead>
                        {table.getHeaderGroups().map((headerGroup) => (
                           <Tr key={headerGroup.id}>
                              {headerGroup.headers.map((header) => (
                                 <Th
                                    // borderRight="1px solid"
                                    borderTop="1px solid"
                                    key={header.id}
                                    colSpan={header.colSpan}
                                    pe="10px"
                                    borderColor={borderColor}
                                    cursor="pointer"
                                    onClick={header.column.getToggleSortingHandler()}>
                                    <Flex
                                       justifyContent="space-between"
                                       align="center"
                                       fontSize={{ sm: '10px', lg: '12px' }}
                                       color="gray.400">
                                       {flexRender(header.column.columnDef.header, header.getContext())}
                                       {{
                                          asc: '↑',
                                          desc: '↓',
                                       }[header.column.getIsSorted()] ?? null}
                                    </Flex>
                                 </Th>
                              ))}
                           </Tr>
                        ))}
                     </Thead>
                     <Tbody>
                        {tdsReport.length === 0 ? (
                           <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
                              <Td colSpan={columns.length} justifyContent="center" alignItems="center" width="100%">
                                 <Grid justifyContent="center" alignItems="center" gap={9}>
                                    <img
                                       src={nodata} // Replace with actual image URL
                                       alt="No Data Found"
                                       width="200px"
                                       height="200px"
                                    />
                                    <GridItem justifySelf="center">
                                       <label>No tds report data found</label>
                                    </GridItem>
                                 </Grid>
                              </Td>
                           </Tr>
                        ) : (
                           // Render data rows if available
                           tdsReport?.map((row, rowIndex) => (
                              <React.Fragment key={row.id}>
                                 <Tr key={row.id} className="editable-row" _hover={{ bg: 'rgba(0, 63, 140, 0.08)' }}>
                                    {columns.map((column) => (
                                       <Td
                                          // borderRight="1px solid"
                                          borderColor="gray.200"
                                          key={column.id}
                                          fontSize={{ sm: '14px' }}
                                          minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                          // borderColor="transparent"
                                       >
                                          {flexRender(column.cell, {
                                             row,
                                             getValue: () => row[column.id],
                                          })}
                                       </Td>
                                    ))}
                                 </Tr>
                              </React.Fragment>
                           ))
                        )}
                     </Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>
      </>
   );
};

export default TDSREPORT;
